import { render } from "./SignInBox.vue?vue&type=template&id=5e71dfb7&scoped=true&ts=true"
import script from "./SignInBox.vue?vue&type=script&lang=ts"
export * from "./SignInBox.vue?vue&type=script&lang=ts"

import "./SignInBox.vue?vue&type=style&index=0&id=5e71dfb7&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e71dfb7"]])

export default __exports__